<template>
  <div>
    <v-autocomplete
      dense
      :value="value"
      :items="items"
      :label="itemInfo.text ? itemInfo.text : itemInfo.key"
      :item-value="fnValue"
      :item-text="fnText"
      :readonly="!isEditing"
      @input="onInput"
    ></v-autocomplete>
  </div>
</template>

<script>
/**
 * 객체 선택 창
 */
import { mapGetters } from "vuex";
import { STORE } from "@/constants";
import { AdminAPI } from "@/api";
export default {
  props: ["value", "itemInfo", "isEditing", "itemList"],

  async mounted() {
    if (this.itemList && this.itemList.length > 0) {
      this.items = this.itemList;
    } else {
      const { data } = await AdminAPI.list({
        objNm: this.itemInfo.select.obj,
        page: 1,
        perpage: 999999,
        search: null,
      });
      this.items = data.list;
    }
  },
  watch: {},

  data: () => ({
    items: [],
  }),

  methods: {
    fnText(item) {
      console.log(item)
      return item[this.itemInfo.select.text];
    },
    fnValue(item) {
      return item[this.itemInfo.select.key];
    },
    onInput(v) {
      this.$emit("input", v);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/SelectForm.vue